import { useTargetLimits } from "@/dashboards/BudgetOptimization/hooks/useTargetLimits";
import type { OptimisationRun } from "@/dashboards/shared/optimisation/optimisationSession";
import { OptimisationBase as OptimisationBaseType } from "@/optimizer";
import { Typography } from "@analytical-alley/ui";
import { AiOutlineWarning } from "react-icons/ai";
import BudgetInput from "./BudgetInput";
import MediaKPIInput from "./MediaKPIInput";
import TotalKPIInput from "./TotalKPIInput";

interface Props {
  optimizationBase: OptimisationBaseType;
  budget: number | undefined;
  setEstimatedBudget: (budget: number | undefined) => void;
  committed: OptimisationRun | null;
}

export const OptimisationBudgetInput = ({ optimizationBase, budget, setEstimatedBudget, committed }: Props) => {
  const { limits, budgetError } = useTargetLimits(optimizationBase, committed);
  const props = { estimatedBudget: budget, setEstimatedBudget, limits };

  return (
    <>
      {optimizationBase === "budget" && <BudgetInput key="budget" {...props} label="Budget" />}
      {optimizationBase === "media_kpi" && <MediaKPIInput key="media_kpi" {...props} label="Media KPI" />}
      {optimizationBase === "total_kpi" && <TotalKPIInput key="total_kpi" {...props} label="Total KPI" />}
      {budgetError && (
        <div className="mt-1 flex items-center gap-1 text-amber-600 dark:text-amber-400">
          <AiOutlineWarning className="shrink-0" />
          <Typography variant="bodyXS" color="inherit">
            {budgetError}
          </Typography>
        </div>
      )}
    </>
  );
};
